require('./bootstrap');
const Swal = require('sweetalert2');
window.Vue = require('vue');
const Editor = require('@tinymce/tinymce-vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


Vue.component('main-sidebar', require('./components/main-sidebar.vue').default);
Vue.component('problem-viewer', require('./components/problem-viewer.vue').default);
Vue.component('model', require('./components/drawer_content/model.vue').default);
Vue.component('assignment', require('./components/drawer_content/assignment.vue').default);
Vue.component('course', require('./components/drawer_content/course.vue').default);
Vue.component('module', require('./components/drawer_content/module.vue').default);
Vue.component('groups', require('./components/drawer_content/group.vue').default);
Vue.component('problem-path', require('./components/drawer_content/path.vue').default);
Vue.component('student', require('./components/student.vue').default);
Vue.component('assignments_progress', require('./components/assignments_progress.vue').default);

Vue.component('delete-modal', require('./Components/modals/delete_modal.vue').default);
Vue.component('disconnected-modal', require('./Components/modals/disconnected_modal.vue').default);
Vue.component('learning-module-modal', require('./Components/modals/learning_module_modal.vue').default);
Vue.component('path-modal', require('./Components/modals/path_modal.vue').default);
Vue.component('practice-modal', require('./Components/modals/practice_modal.vue').default);
Vue.component('problem-modal', require('./Components/modals/problem_modal.vue').default);
Vue.component('stats-modal', require('./Components/modals/stats_modal.vue').default);
Vue.component('student-modal', require('./Components/modals/student_modal.vue').default);
Vue.component('timedout-modal', require('./Components/modals/timedout-modal.vue').default);

Vue.filter('stripAndTruncate', function (value, stop, clamp) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
});

Vue.filter('striphtml', function (value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text;
});

Vue.filter('truncate', function (text, stop, clamp) {//wierd stuff is going on with this...
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
});

window.bus = new Vue();

var sidebar = null;
if($("#sidebar").length > 0) {
    sidebar = new Vue({
        el: '#sidebar',
    });
}

window.problemViewer = null;
if($("#problem-viewer").length > 0) {
    window.problemViewer = new Vue({
        el: '#problem-viewer',
    });
}

var $body = $('body');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function openSidebar(){
    $body.addClass('show-nav').removeClass('hide-nav');
    sidebarSize = 0;

    var pathraw = window.location.pathname;
    var path = pathraw.split("/");
    if(path[1] == "dbl-models" || path[1] == "student-assignment") {
        getSize(true);
    }
}

function closeSidebar(){
    $body.removeClass('show-nav').addClass('hide-nav');
    sidebarSize = -350;

    var pathraw = window.location.pathname;
    var path = pathraw.split("/");
    if(path[1] == "dbl-models" || path[1] == "student-assignment") {
        getSize(true);
    }
}

function toggleSidebar(){
    if ($('.nav-toggle').children('.fa-bars:visible').length) {
        openSidebar();
    }
    else {
        closeSidebar();
    }
}

$('.nav-toggle').click(function() {
    toggleSidebar();
});

$(window).resize(function() {
    $body.removeClass('show-nav hide-nav');
});

$("#loadingSpinner").remove();

// $('.edit-btn').click(function() {
//     $(this).addClass('active-mode').attr('disabled', true);
//     $(this).siblings().removeClass('active-mode').attr('disabled', false);
// });
